package com.hyperether.goodjob.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String
import kotlin.collections.Collection

public class AppDatabaseQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> getWorkspaces(mapper: (
    id: Long,
    _id: String?,
    name: String?,
    type: String?,
    user_id: String?,
    plan: String?,
    workspaceType: String?,
    lastAccessed: String?,
  ) -> T): Query<T> = Query(1_734_452_596, arrayOf("Workspace"), driver, "AppDatabase.sq",
      "getWorkspaces",
      "SELECT Workspace.id, Workspace._id, Workspace.name, Workspace.type, Workspace.user_id, Workspace.plan, Workspace.workspaceType, Workspace.lastAccessed FROM Workspace") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7)
    )
  }

  public fun getWorkspaces(): Query<Workspace> = getWorkspaces { id, _id, name, type, user_id, plan,
      workspaceType, lastAccessed ->
    Workspace(
      id,
      _id,
      name,
      type,
      user_id,
      plan,
      workspaceType,
      lastAccessed
    )
  }

  public fun <T : Any> getWorkspaceById(_id: String?, mapper: (
    id: Long,
    _id: String?,
    name: String?,
    type: String?,
    user_id: String?,
    plan: String?,
    workspaceType: String?,
    lastAccessed: String?,
  ) -> T): Query<T> = GetWorkspaceByIdQuery(_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7)
    )
  }

  public fun getWorkspaceById(_id: String?): Query<Workspace> = getWorkspaceById(_id) { id, _id_,
      name, type, user_id, plan, workspaceType, lastAccessed ->
    Workspace(
      id,
      _id_,
      name,
      type,
      user_id,
      plan,
      workspaceType,
      lastAccessed
    )
  }

  public fun <T : Any> getUsers(mapper: (
    id: Long,
    _id: String?,
    fullName: String?,
    email: String?,
    password: String?,
    confirmStatus: String?,
    role: String?,
    workspace_ids: String?,
    planId: String?,
    phone: String?,
    city: String?,
    contry: String?,
    zip: String?,
    address: String?,
    status: String?,
    skills: String?,
    teams: String?,
    customerId: String?,
    upcomingLeave: String?,
    workingHours: String?,
    pendingPlanId: String?,
    subscriptionEndsAt: String?,
    lang: String?,
  ) -> T): Query<T> = Query(-120_025_774, arrayOf("User"), driver, "AppDatabase.sq", "getUsers",
      "SELECT User.id, User._id, User.fullName, User.email, User.password, User.confirmStatus, User.role, User.workspace_ids, User.planId, User.phone, User.city, User.contry, User.zip, User.address, User.status, User.skills, User.teams, User.customerId, User.upcomingLeave, User.workingHours, User.pendingPlanId, User.subscriptionEndsAt, User.lang FROM User") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getString(14),
      cursor.getString(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getString(19),
      cursor.getString(20),
      cursor.getString(21),
      cursor.getString(22)
    )
  }

  public fun getUsers(): Query<User> = getUsers { id, _id, fullName, email, password, confirmStatus,
      role, workspace_ids, planId, phone, city, contry, zip, address, status, skills, teams,
      customerId, upcomingLeave, workingHours, pendingPlanId, subscriptionEndsAt, lang ->
    User(
      id,
      _id,
      fullName,
      email,
      password,
      confirmStatus,
      role,
      workspace_ids,
      planId,
      phone,
      city,
      contry,
      zip,
      address,
      status,
      skills,
      teams,
      customerId,
      upcomingLeave,
      workingHours,
      pendingPlanId,
      subscriptionEndsAt,
      lang
    )
  }

  public fun <T : Any> getPlans(mapper: (
    id: Long,
    _id: String?,
    name: String?,
    price: Double?,
    perMonth: Double?,
    description: String?,
    storage: String?,
    planSupport: String?,
    limitUsers: Long?,
    limitManagers: Long?,
    isPopular: Long?,
    currency: String?,
    interval: String?,
    stripeProductId: String?,
    stripePriceId: String?,
    type: String?,
    descriptions: String?,
    names: String?,
    storages: String?,
    planSupports: String?,
  ) -> T): Query<T> = Query(-124_855_884, arrayOf("Plan"), driver, "AppDatabase.sq", "getPlans", """
  |SELECT Plan.id, Plan._id, Plan.name, Plan.price, Plan.perMonth, Plan.description, Plan.storage, Plan.planSupport, Plan.limitUsers, Plan.limitManagers, Plan.isPopular, Plan.currency, Plan.interval, Plan.stripeProductId, Plan.stripePriceId, Plan.type, Plan.descriptions, Plan.names, Plan.storages, Plan.planSupports FROM Plan
  |ORDER BY price ASC
  """.trimMargin()) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getDouble(3),
      cursor.getDouble(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getString(14),
      cursor.getString(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getString(19)
    )
  }

  public fun getPlans(): Query<Plan> = getPlans { id, _id, name, price, perMonth, description,
      storage, planSupport, limitUsers, limitManagers, isPopular, currency, interval,
      stripeProductId, stripePriceId, type, descriptions, names, storages, planSupports ->
    Plan(
      id,
      _id,
      name,
      price,
      perMonth,
      description,
      storage,
      planSupport,
      limitUsers,
      limitManagers,
      isPopular,
      currency,
      interval,
      stripeProductId,
      stripePriceId,
      type,
      descriptions,
      names,
      storages,
      planSupports
    )
  }

  public fun <T : Any> getPlanById(_id: String?, mapper: (
    id: Long,
    _id: String?,
    name: String?,
    price: Double?,
    perMonth: Double?,
    description: String?,
    storage: String?,
    planSupport: String?,
    limitUsers: Long?,
    limitManagers: Long?,
    isPopular: Long?,
    currency: String?,
    interval: String?,
    stripeProductId: String?,
    stripePriceId: String?,
    type: String?,
    descriptions: String?,
    names: String?,
    storages: String?,
    planSupports: String?,
  ) -> T): Query<T> = GetPlanByIdQuery(_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getDouble(3),
      cursor.getDouble(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getLong(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getString(14),
      cursor.getString(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getString(19)
    )
  }

  public fun getPlanById(_id: String?): Query<Plan> = getPlanById(_id) { id, _id_, name, price,
      perMonth, description, storage, planSupport, limitUsers, limitManagers, isPopular, currency,
      interval, stripeProductId, stripePriceId, type, descriptions, names, storages, planSupports ->
    Plan(
      id,
      _id_,
      name,
      price,
      perMonth,
      description,
      storage,
      planSupport,
      limitUsers,
      limitManagers,
      isPopular,
      currency,
      interval,
      stripeProductId,
      stripePriceId,
      type,
      descriptions,
      names,
      storages,
      planSupports
    )
  }

  public fun <T : Any> getJobs(mapper: (
    id: Long,
    _id: String?,
    jobTitle: String?,
    status: String?,
    assignees: String?,
    creatorId: String?,
    workspaceId: String?,
    start_at: String?,
    end_at: String?,
    repeat: String?,
    repeatInterval: String?,
    startDate: String?,
    dueDate: String?,
    jobDuration: Long?,
    steps: String?,
    userId: String?,
    contactId: String?,
    contactSiteName: String?,
    contactParentId: String?,
    notes: String?,
    fileObjects: String?,
    completionReport: String?,
  ) -> T): Query<T> = Query(-142_750_772, arrayOf("Job"), driver, "AppDatabase.sq", "getJobs",
      "SELECT Job.id, Job._id, Job.jobTitle, Job.status, Job.assignees, Job.creatorId, Job.workspaceId, Job.start_at, Job.end_at, Job.repeat, Job.repeatInterval, Job.startDate, Job.dueDate, Job.jobDuration, Job.steps, Job.userId, Job.contactId, Job.contactSiteName, Job.contactParentId, Job.notes, Job.fileObjects, Job.completionReport FROM Job") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getLong(13),
      cursor.getString(14),
      cursor.getString(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getString(19),
      cursor.getString(20),
      cursor.getString(21)
    )
  }

  public fun getJobs(): Query<Job> = getJobs { id, _id, jobTitle, status, assignees, creatorId,
      workspaceId, start_at, end_at, repeat, repeatInterval, startDate, dueDate, jobDuration, steps,
      userId, contactId, contactSiteName, contactParentId, notes, fileObjects, completionReport ->
    Job(
      id,
      _id,
      jobTitle,
      status,
      assignees,
      creatorId,
      workspaceId,
      start_at,
      end_at,
      repeat,
      repeatInterval,
      startDate,
      dueDate,
      jobDuration,
      steps,
      userId,
      contactId,
      contactSiteName,
      contactParentId,
      notes,
      fileObjects,
      completionReport
    )
  }

  public fun <T : Any> getJobsByWorkspaceId(workspaceId: String?, mapper: (
    id: Long,
    _id: String?,
    jobTitle: String?,
    status: String?,
    assignees: String?,
    creatorId: String?,
    workspaceId: String?,
    start_at: String?,
    end_at: String?,
    repeat: String?,
    repeatInterval: String?,
    startDate: String?,
    dueDate: String?,
    jobDuration: Long?,
    steps: String?,
    userId: String?,
    contactId: String?,
    contactSiteName: String?,
    contactParentId: String?,
    notes: String?,
    fileObjects: String?,
    completionReport: String?,
  ) -> T): Query<T> = GetJobsByWorkspaceIdQuery(workspaceId) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getLong(13),
      cursor.getString(14),
      cursor.getString(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getString(19),
      cursor.getString(20),
      cursor.getString(21)
    )
  }

  public fun getJobsByWorkspaceId(workspaceId: String?): Query<Job> =
      getJobsByWorkspaceId(workspaceId) { id, _id, jobTitle, status, assignees, creatorId,
      workspaceId_, start_at, end_at, repeat, repeatInterval, startDate, dueDate, jobDuration,
      steps, userId, contactId, contactSiteName, contactParentId, notes, fileObjects,
      completionReport ->
    Job(
      id,
      _id,
      jobTitle,
      status,
      assignees,
      creatorId,
      workspaceId_,
      start_at,
      end_at,
      repeat,
      repeatInterval,
      startDate,
      dueDate,
      jobDuration,
      steps,
      userId,
      contactId,
      contactSiteName,
      contactParentId,
      notes,
      fileObjects,
      completionReport
    )
  }

  public fun <T : Any> getJobsByContactId(contactParentId: String?, mapper: (
    id: Long,
    _id: String?,
    jobTitle: String?,
    status: String?,
    assignees: String?,
    creatorId: String?,
    workspaceId: String?,
    start_at: String?,
    end_at: String?,
    repeat: String?,
    repeatInterval: String?,
    startDate: String?,
    dueDate: String?,
    jobDuration: Long?,
    steps: String?,
    userId: String?,
    contactId: String?,
    contactSiteName: String?,
    contactParentId: String?,
    notes: String?,
    fileObjects: String?,
    completionReport: String?,
  ) -> T): Query<T> = GetJobsByContactIdQuery(contactParentId) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getLong(13),
      cursor.getString(14),
      cursor.getString(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getString(19),
      cursor.getString(20),
      cursor.getString(21)
    )
  }

  public fun getJobsByContactId(contactParentId: String?): Query<Job> =
      getJobsByContactId(contactParentId) { id, _id, jobTitle, status, assignees, creatorId,
      workspaceId, start_at, end_at, repeat, repeatInterval, startDate, dueDate, jobDuration, steps,
      userId, contactId, contactSiteName, contactParentId_, notes, fileObjects, completionReport ->
    Job(
      id,
      _id,
      jobTitle,
      status,
      assignees,
      creatorId,
      workspaceId,
      start_at,
      end_at,
      repeat,
      repeatInterval,
      startDate,
      dueDate,
      jobDuration,
      steps,
      userId,
      contactId,
      contactSiteName,
      contactParentId_,
      notes,
      fileObjects,
      completionReport
    )
  }

  public fun <T : Any> getJobById(_id: String?, mapper: (
    id: Long,
    _id: String?,
    jobTitle: String?,
    status: String?,
    assignees: String?,
    creatorId: String?,
    workspaceId: String?,
    start_at: String?,
    end_at: String?,
    repeat: String?,
    repeatInterval: String?,
    startDate: String?,
    dueDate: String?,
    jobDuration: Long?,
    steps: String?,
    userId: String?,
    contactId: String?,
    contactSiteName: String?,
    contactParentId: String?,
    notes: String?,
    fileObjects: String?,
    completionReport: String?,
  ) -> T): Query<T> = GetJobByIdQuery(_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getLong(13),
      cursor.getString(14),
      cursor.getString(15),
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18),
      cursor.getString(19),
      cursor.getString(20),
      cursor.getString(21)
    )
  }

  public fun getJobById(_id: String?): Query<Job> = getJobById(_id) { id, _id_, jobTitle, status,
      assignees, creatorId, workspaceId, start_at, end_at, repeat, repeatInterval, startDate,
      dueDate, jobDuration, steps, userId, contactId, contactSiteName, contactParentId, notes,
      fileObjects, completionReport ->
    Job(
      id,
      _id_,
      jobTitle,
      status,
      assignees,
      creatorId,
      workspaceId,
      start_at,
      end_at,
      repeat,
      repeatInterval,
      startDate,
      dueDate,
      jobDuration,
      steps,
      userId,
      contactId,
      contactSiteName,
      contactParentId,
      notes,
      fileObjects,
      completionReport
    )
  }

  public fun <T : Any> getContacts(mapper: (
    id: Long,
    _id: String?,
    name: String?,
    contactType: String?,
    industry: String?,
    address: String?,
    email: String?,
    phone: String?,
    personName: String?,
    personEmail: String?,
    personAddress: String?,
    personPhone: String?,
    workspaceId: String?,
  ) -> T): Query<T> = Query(1_718_133_961, arrayOf("Contact"), driver, "AppDatabase.sq",
      "getContacts",
      "SELECT Contact.id, Contact._id, Contact.name, Contact.contactType, Contact.industry, Contact.address, Contact.email, Contact.phone, Contact.personName, Contact.personEmail, Contact.personAddress, Contact.personPhone, Contact.workspaceId FROM Contact") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12)
    )
  }

  public fun getContacts(): Query<Contact> = getContacts { id, _id, name, contactType, industry,
      address, email, phone, personName, personEmail, personAddress, personPhone, workspaceId ->
    Contact(
      id,
      _id,
      name,
      contactType,
      industry,
      address,
      email,
      phone,
      personName,
      personEmail,
      personAddress,
      personPhone,
      workspaceId
    )
  }

  public fun <T : Any> getContactById(_id: String?, mapper: (
    id: Long,
    _id: String?,
    name: String?,
    contactType: String?,
    industry: String?,
    address: String?,
    email: String?,
    phone: String?,
    personName: String?,
    personEmail: String?,
    personAddress: String?,
    personPhone: String?,
    workspaceId: String?,
  ) -> T): Query<T> = GetContactByIdQuery(_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12)
    )
  }

  public fun getContactById(_id: String?): Query<Contact> = getContactById(_id) { id, _id_, name,
      contactType, industry, address, email, phone, personName, personEmail, personAddress,
      personPhone, workspaceId ->
    Contact(
      id,
      _id_,
      name,
      contactType,
      industry,
      address,
      email,
      phone,
      personName,
      personEmail,
      personAddress,
      personPhone,
      workspaceId
    )
  }

  public fun <T : Any> getSites(mapper: (
    id: Long,
    _id: String?,
    personName: String?,
    personAddress: String?,
    personPhone: String?,
    siteName: String?,
    parentId: String?,
    parentName: String?,
    personEmail: String?,
    workspaceId: String?,
  ) -> T): Query<T> = Query(-122_156_714, arrayOf("Site"), driver, "AppDatabase.sq", "getSites",
      "SELECT Site.id, Site._id, Site.personName, Site.personAddress, Site.personPhone, Site.siteName, Site.parentId, Site.parentName, Site.personEmail, Site.workspaceId FROM Site") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9)
    )
  }

  public fun getSites(): Query<Site> = getSites { id, _id, personName, personAddress, personPhone,
      siteName, parentId, parentName, personEmail, workspaceId ->
    Site(
      id,
      _id,
      personName,
      personAddress,
      personPhone,
      siteName,
      parentId,
      parentName,
      personEmail,
      workspaceId
    )
  }

  public fun <T : Any> getSiteById(_id: String?, mapper: (
    id: Long,
    _id: String?,
    personName: String?,
    personAddress: String?,
    personPhone: String?,
    siteName: String?,
    parentId: String?,
    parentName: String?,
    personEmail: String?,
    workspaceId: String?,
  ) -> T): Query<T> = GetSiteByIdQuery(_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9)
    )
  }

  public fun getSiteById(_id: String?): Query<Site> = getSiteById(_id) { id, _id_, personName,
      personAddress, personPhone, siteName, parentId, parentName, personEmail, workspaceId ->
    Site(
      id,
      _id_,
      personName,
      personAddress,
      personPhone,
      siteName,
      parentId,
      parentName,
      personEmail,
      workspaceId
    )
  }

  public fun <T : Any> getSitesByContactId(_id: String?, mapper: (
    id: Long,
    _id: String?,
    personName: String?,
    personAddress: String?,
    personPhone: String?,
    siteName: String?,
    parentId: String?,
    parentName: String?,
    personEmail: String?,
    workspaceId: String?,
  ) -> T): Query<T> = GetSitesByContactIdQuery(_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9)
    )
  }

  public fun getSitesByContactId(_id: String?): Query<Site> = getSitesByContactId(_id) { id, _id_,
      personName, personAddress, personPhone, siteName, parentId, parentName, personEmail,
      workspaceId ->
    Site(
      id,
      _id_,
      personName,
      personAddress,
      personPhone,
      siteName,
      parentId,
      parentName,
      personEmail,
      workspaceId
    )
  }

  public fun <T : Any> getTeams(mapper: (
    id: Long,
    _id: String?,
    name: String?,
    workspaceId: String?,
    employees: String?,
    type: String?,
    createdAt: String?,
    updatedAt: String?,
  ) -> T): Query<T> = Query(-121_370_368, arrayOf("Team"), driver, "AppDatabase.sq", "getTeams",
      "SELECT Team.id, Team._id, Team.name, Team.workspaceId, Team.employees, Team.type, Team.createdAt, Team.updatedAt FROM Team") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7)
    )
  }

  public fun getTeams(): Query<Team> = getTeams { id, _id, name, workspaceId, employees, type,
      createdAt, updatedAt ->
    Team(
      id,
      _id,
      name,
      workspaceId,
      employees,
      type,
      createdAt,
      updatedAt
    )
  }

  public fun <T : Any> getSkillsByWorkspaceId(workspaceId: String?, mapper: (
    id: Long,
    _id: String?,
    name: String?,
    workspaceId: String?,
  ) -> T): Query<T> = GetSkillsByWorkspaceIdQuery(workspaceId) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3)
    )
  }

  public fun getSkillsByWorkspaceId(workspaceId: String?): Query<Skills> =
      getSkillsByWorkspaceId(workspaceId) { id, _id, name, workspaceId_ ->
    Skills(
      id,
      _id,
      name,
      workspaceId_
    )
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateWorkspaceByID(
    _id: String?,
    name: String?,
    type: String?,
    user_id: String?,
    plan: String?,
    workspaceType: String?,
    lastAccessed: String?,
    id: String?,
  ): Long {
    val result = driver.execute(null, """
        |UPDATE Workspace
        |SET
        |    _id = ?,
        |    name = ?,
        |    type = ?,
        |    user_id = ?,
        |    plan = ?,
        |    workspaceType = ?,
        |    lastAccessed = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 8) {
          bindString(0, _id)
          bindString(1, name)
          bindString(2, type)
          bindString(3, user_id)
          bindString(4, plan)
          bindString(5, workspaceType)
          bindString(6, lastAccessed)
          bindString(7, id)
        }.await()
    notifyQueries(1_541_191_326) { emit ->
      emit("Workspace")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllWorkspaces(): Long {
    val result = driver.execute(-820_861_420, """DELETE FROM Workspace""", 0).await()
    notifyQueries(-820_861_420) { emit ->
      emit("Workspace")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertWorkspace(
    _id: String?,
    name: String?,
    type: String?,
    user_id: String?,
    plan: String?,
    workspaceType: String?,
    lastAccessed: String?,
  ): Long {
    val result = driver.execute(627_822_812, """
        |INSERT OR REPLACE INTO Workspace(_id, name, type, user_id, plan, workspaceType, lastAccessed)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, _id)
          bindString(1, name)
          bindString(2, type)
          bindString(3, user_id)
          bindString(4, plan)
          bindString(5, workspaceType)
          bindString(6, lastAccessed)
        }.await()
    notifyQueries(627_822_812) { emit ->
      emit("Workspace")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteWorkspaceById(id: Long): Long {
    val result = driver.execute(1_289_611_548, """DELETE FROM Workspace WHERE id = ?""", 1) {
          bindLong(0, id)
        }.await()
    notifyQueries(1_289_611_548) { emit ->
      emit("Workspace")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertUser(
    _id: String?,
    fullName: String?,
    email: String?,
    password: String?,
    confirmStatus: String?,
    role: String?,
    workspace_ids: String?,
    address: String?,
    phone: String?,
    city: String?,
    contry: String?,
    zip: String?,
    status: String?,
    skills: String?,
    teams: String?,
    customerId: String?,
    upcomingLeave: String?,
    workingHours: String?,
    pendingPlanId: String?,
    subscriptionEndsAt: String?,
    lang: String?,
  ): Long {
    val result = driver.execute(695_809_828, """
        |INSERT OR REPLACE INTO User(_id, fullName, email, password, confirmStatus, role, workspace_ids, address, phone, city, contry, zip, status, skills, teams, customerId, upcomingLeave, workingHours, pendingPlanId, subscriptionEndsAt, lang)
        |VALUES (?,?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 21) {
          bindString(0, _id)
          bindString(1, fullName)
          bindString(2, email)
          bindString(3, password)
          bindString(4, confirmStatus)
          bindString(5, role)
          bindString(6, workspace_ids)
          bindString(7, address)
          bindString(8, phone)
          bindString(9, city)
          bindString(10, contry)
          bindString(11, zip)
          bindString(12, status)
          bindString(13, skills)
          bindString(14, teams)
          bindString(15, customerId)
          bindString(16, upcomingLeave)
          bindString(17, workingHours)
          bindString(18, pendingPlanId)
          bindString(19, subscriptionEndsAt)
          bindString(20, lang)
        }.await()
    notifyQueries(695_809_828) { emit ->
      emit("User")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteUsersByIds(id: Collection<Long>): Long {
    val idIndexes = createArguments(count = id.size)
    val result = driver.execute(null, """DELETE FROM User WHERE id IN $idIndexes""", id.size) {
          id.forEachIndexed { index, id_ ->
            bindLong(index, id_)
          }
        }.await()
    notifyQueries(-1_303_902_524) { emit ->
      emit("User")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteUserById(_id: String?): Long {
    val result = driver.execute(null,
        """DELETE FROM User WHERE _id ${ if (_id == null) "IS" else "=" } ?""", 1) {
          bindString(0, _id)
        }.await()
    notifyQueries(82_150_920) { emit ->
      emit("User")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllUsers(): Long {
    val result = driver.execute(2_138_155_186, """DELETE FROM User""", 0).await()
    notifyQueries(2_138_155_186) { emit ->
      emit("User")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateUserById(
    fullName: String?,
    _id: String?,
    email: String?,
    password: String?,
    confirmStatus: String?,
    role: String?,
    workspace_ids: String?,
    planId: String?,
    phone: String?,
    city: String?,
    country: String?,
    zip: String?,
    address: String?,
    status: String?,
    skills: String?,
    teams: String?,
    customerId: String?,
    upcomingLeave: String?,
    workingHours: String?,
    pendingPlanId: String?,
    subscriptionEndsAt: String?,
    lang: String?,
    id: String?,
  ): Long {
    val result = driver.execute(null, """
        |UPDATE User
        |SET
        |    fullName = ?,
        |    _id = ?,
        |    email = ?,
        |    password = ?,
        |    confirmStatus = ?,
        |    role = ?,
        |    workspace_ids = ?,
        |    planId = ?,
        |    phone = ?,
        |    city = ?,
        |    contry = ?,
        |    zip = ?,
        |    address = ?,
        |    status = ?,
        |    skills = ?,
        |    teams = ?,
        |    customerId = ?,
        |    upcomingLeave = ?,
        |    workingHours = ?,
        |    pendingPlanId = ?,
        |    subscriptionEndsAt = ?,
        |    lang = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 23) {
          bindString(0, fullName)
          bindString(1, _id)
          bindString(2, email)
          bindString(3, password)
          bindString(4, confirmStatus)
          bindString(5, role)
          bindString(6, workspace_ids)
          bindString(7, planId)
          bindString(8, phone)
          bindString(9, city)
          bindString(10, country)
          bindString(11, zip)
          bindString(12, address)
          bindString(13, status)
          bindString(14, skills)
          bindString(15, teams)
          bindString(16, customerId)
          bindString(17, upcomingLeave)
          bindString(18, workingHours)
          bindString(19, pendingPlanId)
          bindString(20, subscriptionEndsAt)
          bindString(21, lang)
          bindString(22, id)
        }.await()
    notifyQueries(-1_289_667_802) { emit ->
      emit("User")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updatePlanById(
    _id: String?,
    name: String?,
    price: Double?,
    perMonth: Double?,
    description: String?,
    storage: String?,
    planSupport: String?,
    limitUsers: Long?,
    limitManagers: Long?,
    isPopular: Long?,
    currency: String?,
    interval: String?,
    stripeProductId: String?,
    stripePriceId: String?,
    type: String?,
    descriptions: String?,
    names: String?,
    storages: String?,
    planSupports: String?,
    id: String?,
  ): Long {
    val result = driver.execute(null, """
        |UPDATE Plan
        |SET
        |    _id = ?,
        |    name = ?,
        |    price = ?,
        |    perMonth = ?,
        |    description = ?,
        |    storage = ?,
        |    planSupport = ?,
        |    limitUsers = ?,
        |    limitManagers = ?,
        |    isPopular = ?,
        |    currency = ?,
        |    interval = ?,
        |    stripeProductId = ?,
        |    stripePriceId = ?,
        |    type = ?,
        |    descriptions = ?,
        |    names = ?,
        |    storages = ?,
        |    planSupports = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 20) {
          bindString(0, _id)
          bindString(1, name)
          bindDouble(2, price)
          bindDouble(3, perMonth)
          bindString(4, description)
          bindString(5, storage)
          bindString(6, planSupport)
          bindLong(7, limitUsers)
          bindLong(8, limitManagers)
          bindLong(9, isPopular)
          bindString(10, currency)
          bindString(11, interval)
          bindString(12, stripeProductId)
          bindString(13, stripePriceId)
          bindString(14, type)
          bindString(15, descriptions)
          bindString(16, names)
          bindString(17, storages)
          bindString(18, planSupports)
          bindString(19, id)
        }.await()
    notifyQueries(845_413_252) { emit ->
      emit("Plan")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertPlan(
    _id: String?,
    name: String?,
    price: Double?,
    perMonth: Double?,
    description: String?,
    storage: String?,
    planSupport: String?,
    limitUsers: Long?,
    limitManagers: Long?,
    isPopular: Long?,
    currency: String?,
    interval: String?,
    stripeProductId: String?,
    stripePriceId: String?,
    type: String?,
    descriptions: String?,
    names: String?,
    storages: String?,
    planSupports: String?,
  ): Long {
    val result = driver.execute(695_654_018, """
        |INSERT OR REPLACE INTO Plan(_id, name, price, perMonth, description, storage, planSupport, limitUsers, limitManagers, isPopular, currency, interval, stripeProductId, stripePriceId, type, descriptions, names, storages, planSupports)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 19) {
          bindString(0, _id)
          bindString(1, name)
          bindDouble(2, price)
          bindDouble(3, perMonth)
          bindString(4, description)
          bindString(5, storage)
          bindString(6, planSupport)
          bindLong(7, limitUsers)
          bindLong(8, limitManagers)
          bindLong(9, isPopular)
          bindString(10, currency)
          bindString(11, interval)
          bindString(12, stripeProductId)
          bindString(13, stripePriceId)
          bindString(14, type)
          bindString(15, descriptions)
          bindString(16, names)
          bindString(17, storages)
          bindString(18, planSupports)
        }.await()
    notifyQueries(695_654_018) { emit ->
      emit("Plan")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deletePlanById(_id: String?): Long {
    val result = driver.execute(null,
        """DELETE FROM Plan WHERE _id ${ if (_id == null) "IS" else "=" } ?""", 1) {
          bindString(0, _id)
        }.await()
    notifyQueries(-2_077_735_322) { emit ->
      emit("Plan")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertJob(
    _id: String?,
    jobTitle: String?,
    status: String?,
    assignees: String?,
    creatorId: String?,
    workspaceId: String?,
    start_at: String?,
    end_at: String?,
    repeat: String?,
    repeatInterval: String?,
    startDate: String?,
    dueDate: String?,
    jobDuration: Long?,
    steps: String?,
    userId: String?,
    contactId: String?,
    contactSiteName: String?,
    contactParentId: String?,
    notes: String?,
    fileObjects: String?,
    completionReport: String?,
  ): Long {
    val result = driver.execute(-670_301_884, """
        |INSERT OR REPLACE INTO Job (
        |    _id, jobTitle, status, assignees, creatorId, workspaceId, start_at, end_at, repeat, repeatInterval, startDate, dueDate, jobDuration, steps, userId, contactId, contactSiteName, contactParentId, notes, fileObjects, completionReport
        |)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?,?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 21) {
          bindString(0, _id)
          bindString(1, jobTitle)
          bindString(2, status)
          bindString(3, assignees)
          bindString(4, creatorId)
          bindString(5, workspaceId)
          bindString(6, start_at)
          bindString(7, end_at)
          bindString(8, repeat)
          bindString(9, repeatInterval)
          bindString(10, startDate)
          bindString(11, dueDate)
          bindLong(12, jobDuration)
          bindString(13, steps)
          bindString(14, userId)
          bindString(15, contactId)
          bindString(16, contactSiteName)
          bindString(17, contactParentId)
          bindString(18, notes)
          bindString(19, fileObjects)
          bindString(20, completionReport)
        }.await()
    notifyQueries(-670_301_884) { emit ->
      emit("Job")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllJobs(): Long {
    val result = driver.execute(899_925_100, """DELETE FROM Job""", 0).await()
    notifyQueries(899_925_100) { emit ->
      emit("Job")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteJobById(_id: String?): Long {
    val result = driver.execute(null,
        """DELETE FROM Job WHERE _id ${ if (_id == null) "IS" else "=" } ?""", 1) {
          bindString(0, _id)
        }.await()
    notifyQueries(373_946_372) { emit ->
      emit("Job")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateJobByID(
    _id: String?,
    jobTitle: String?,
    status: String?,
    assignees: String?,
    creatorId: String?,
    workspaceId: String?,
    start_at: String?,
    end_at: String?,
    repeat: String?,
    repeatInterval: String?,
    startDate: String?,
    dueDate: String?,
    jobDuration: Long?,
    steps: String?,
    userId: String?,
    contactId: String?,
    contactSiteName: String?,
    contactParentId: String?,
    notes: String?,
    fileObjects: String?,
    completionReport: String?,
    id: String?,
  ): Long {
    val result = driver.execute(null, """
        |UPDATE Job
        |SET
        |    _id = ?,
        |    jobTitle = ?,
        |    status = ?,
        |    assignees = ?,
        |    creatorId = ?,
        |    workspaceId = ?,
        |    start_at = ?,
        |    end_at = ?,
        |    repeat = ?,
        |    repeatInterval = ?,
        |    startDate= ?,
        |    dueDate = ?,
        |    jobDuration = ?,
        |    steps = ?,
        |    userId = ?,
        |    contactId = ?,
        |    contactSiteName = ?,
        |    contactParentId = ?,
        |    notes = ?,
        |    fileObjects = ?,
        |    completionReport = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 22) {
          bindString(0, _id)
          bindString(1, jobTitle)
          bindString(2, status)
          bindString(3, assignees)
          bindString(4, creatorId)
          bindString(5, workspaceId)
          bindString(6, start_at)
          bindString(7, end_at)
          bindString(8, repeat)
          bindString(9, repeatInterval)
          bindString(10, startDate)
          bindString(11, dueDate)
          bindLong(12, jobDuration)
          bindString(13, steps)
          bindString(14, userId)
          bindString(15, contactId)
          bindString(16, contactSiteName)
          bindString(17, contactParentId)
          bindString(18, notes)
          bindString(19, fileObjects)
          bindString(20, completionReport)
          bindString(21, id)
        }.await()
    notifyQueries(-917_231_866) { emit ->
      emit("Job")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateJobStatusById(status: String?, id: String?): Long {
    val result = driver.execute(null, """
        |UPDATE Job
        |SET status = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 2) {
          bindString(0, status)
          bindString(1, id)
        }.await()
    notifyQueries(-1_800_580_296) { emit ->
      emit("Job")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateJobCompletionReport(completionReport: String?, id: String?): Long {
    val result = driver.execute(null, """
        |UPDATE Job
        |SET completionReport = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 2) {
          bindString(0, completionReport)
          bindString(1, id)
        }.await()
    notifyQueries(-287_359_612) { emit ->
      emit("Job")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateFiles(files: String?, id: String?): Long {
    val result = driver.execute(null, """
        |UPDATE Job
        |SET fileObjects = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 2) {
          bindString(0, files)
          bindString(1, id)
        }.await()
    notifyQueries(-389_173_714) { emit ->
      emit("Job")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateSteps(steps: String?, id: String?): Long {
    val result = driver.execute(null, """
        |UPDATE Job
        |SET steps = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 2) {
          bindString(0, steps)
          bindString(1, id)
        }.await()
    notifyQueries(-376_846_626) { emit ->
      emit("Job")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertContact(
    _id: String?,
    name: String?,
    contactType: String?,
    industry: String?,
    address: String?,
    email: String?,
    phone: String?,
    personName: String?,
    personEmail: String?,
    personAddress: String?,
    personPhone: String?,
    workspaceId: String?,
  ): Long {
    val result = driver.execute(-1_837_797_849, """
        |INSERT OR REPLACE INTO Contact (
        |    _id, name, contactType, industry, address, email, phone, personName, personEmail, personAddress, personPhone, workspaceId
        |)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 12) {
          bindString(0, _id)
          bindString(1, name)
          bindString(2, contactType)
          bindString(3, industry)
          bindString(4, address)
          bindString(5, email)
          bindString(6, phone)
          bindString(7, personName)
          bindString(8, personEmail)
          bindString(9, personAddress)
          bindString(10, personPhone)
          bindString(11, workspaceId)
        }.await()
    notifyQueries(-1_837_797_849) { emit ->
      emit("Contact")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateContactByID(
    name: String?,
    _id: String?,
    contactType: String?,
    industry: String?,
    address: String?,
    email: String?,
    phone: String?,
    personName: String?,
    personEmail: String?,
    personAddress: String?,
    personPhone: String?,
    workspaceId: String?,
    id: String?,
  ): Long {
    val result = driver.execute(null, """
        |UPDATE Contact
        |SET
        |    name = ?,
        |    _id = ?,
        |    contactType = ?,
        |    industry = ?,
        |    address = ?,
        |    email = ?,
        |    phone = ?,
        |    personName = ?,
        |    personEmail = ?,
        |    personAddress = ?,
        |    personPhone = ?,
        |    workspaceId = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 13) {
          bindString(0, name)
          bindString(1, _id)
          bindString(2, contactType)
          bindString(3, industry)
          bindString(4, address)
          bindString(5, email)
          bindString(6, phone)
          bindString(7, personName)
          bindString(8, personEmail)
          bindString(9, personAddress)
          bindString(10, personPhone)
          bindString(11, workspaceId)
          bindString(12, id)
        }.await()
    notifyQueries(-1_984_368_023) { emit ->
      emit("Contact")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteContactById(_id: String?): Long {
    val result = driver.execute(null,
        """DELETE FROM Contact WHERE _id ${ if (_id == null) "IS" else "=" } ?""", 1) {
          bindString(0, _id)
        }.await()
    notifyQueries(-746_642_329) { emit ->
      emit("Contact")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllContacts(): Long {
    val result = driver.execute(-1_180_611_223, """DELETE FROM Contact""", 0).await()
    notifyQueries(-1_180_611_223) { emit ->
      emit("Contact")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertSite(
    _id: String?,
    personName: String?,
    personAddress: String?,
    personPhone: String?,
    siteName: String?,
    parentId: String?,
    parentName: String?,
    personEmail: String?,
    workspaceId: String?,
  ): Long {
    val result = driver.execute(695_741_088, """
        |INSERT OR REPLACE INTO Site (
        |     _id, personName, personAddress, personPhone, siteName, parentId, parentName, personEmail, workspaceId
        |)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          bindString(0, _id)
          bindString(1, personName)
          bindString(2, personAddress)
          bindString(3, personPhone)
          bindString(4, siteName)
          bindString(5, parentId)
          bindString(6, parentName)
          bindString(7, personEmail)
          bindString(8, workspaceId)
        }.await()
    notifyQueries(695_741_088) { emit ->
      emit("Site")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteSiteById(_id: String?): Long {
    val result = driver.execute(null,
        """DELETE FROM Site WHERE _id ${ if (_id == null) "IS" else "=" } ?""", 1) {
          bindString(0, _id)
        }.await()
    notifyQueries(1_023_826_820) { emit ->
      emit("Site")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateSite(
    personName: String?,
    personAddress: String?,
    personPhone: String?,
    siteName: String?,
    parentId: String?,
    parentName: String?,
    personEmail: String?,
    workspaceId: String?,
    _id: String?,
  ): Long {
    val result = driver.execute(null, """
        |UPDATE Site
        |SET
        |    personName =?,
        |    personAddress = ?,
        |    personPhone = ?,
        |    siteName = ?,
        |    parentId = ?,
        |    parentName = ?,
        |    personEmail = ?,
        |    workspaceId = ?
        |WHERE _id ${ if (_id == null) "IS" else "=" } ?
        """.trimMargin(), 9) {
          bindString(0, personName)
          bindString(1, personAddress)
          bindString(2, personPhone)
          bindString(3, siteName)
          bindString(4, parentId)
          bindString(5, parentName)
          bindString(6, personEmail)
          bindString(7, workspaceId)
          bindString(8, _id)
        }.await()
    notifyQueries(-566_355_792) { emit ->
      emit("Site")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllSites(): Long {
    val result = driver.execute(2_136_024_246, """DELETE FROM Site""", 0).await()
    notifyQueries(2_136_024_246) { emit ->
      emit("Site")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertTeam(
    _id: String?,
    name: String?,
    workspaceId: String?,
    type: String?,
    employees: String?,
    createdAt: String?,
    updatedAt: String?,
  ): Long {
    val result = driver.execute(695_766_454, """
        |INSERT OR REPLACE INTO Team (
        |     _id, name, workspaceId, type, employees, createdAt, updatedAt
        |)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, _id)
          bindString(1, name)
          bindString(2, workspaceId)
          bindString(3, type)
          bindString(4, employees)
          bindString(5, createdAt)
          bindString(6, updatedAt)
        }.await()
    notifyQueries(695_766_454) { emit ->
      emit("Team")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateTeamByID(
    name: String?,
    _id: String?,
    workspaceId: String?,
    type: String?,
    employees: String?,
    updatedAt: String?,
    createdAt: String?,
    id: String?,
  ): Long {
    val result = driver.execute(null, """
        |UPDATE Team
        |SET
        |    name = ?,
        |    _id = ?,
        |    workspaceId = ?,
        |    type = ?,
        |    employees = ?,
        |    updatedAt = ?,
        |    createdAt = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 8) {
          bindString(0, name)
          bindString(1, _id)
          bindString(2, workspaceId)
          bindString(3, type)
          bindString(4, employees)
          bindString(5, updatedAt)
          bindString(6, createdAt)
          bindString(7, id)
        }.await()
    notifyQueries(1_603_205_272) { emit ->
      emit("Team")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteTeamById(_id: String?): Long {
    val result = driver.execute(null,
        """DELETE FROM Team WHERE _id ${ if (_id == null) "IS" else "=" } ?""", 1) {
          bindString(0, _id)
        }.await()
    notifyQueries(-1_319_943_270) { emit ->
      emit("Team")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllTeams(): Long {
    val result = driver.execute(2_136_810_592, """DELETE FROM Team""", 0).await()
    notifyQueries(2_136_810_592) { emit ->
      emit("Team")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertSkill(
    _id: String?,
    name: String?,
    workspaceId: String?,
  ): Long {
    val result = driver.execute(93_186_584, """
        |INSERT OR REPLACE INTO Skills (
        |    _id, name, workspaceId
        |)
        |VALUES (?, ?, ?)
        """.trimMargin(), 3) {
          bindString(0, _id)
          bindString(1, name)
          bindString(2, workspaceId)
        }.await()
    notifyQueries(93_186_584) { emit ->
      emit("Skills")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateSkillById(
    name: String?,
    workspaceId: String?,
    id: String?,
  ): Long {
    val result = driver.execute(null, """
        |UPDATE Skills
        |SET
        | name = ?,
        | workspaceId = ?
        |WHERE _id ${ if (id == null) "IS" else "=" } ?
        """.trimMargin(), 3) {
          bindString(0, name)
          bindString(1, workspaceId)
          bindString(2, id)
        }.await()
    notifyQueries(352_799_226) { emit ->
      emit("Skills")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteAllSkills(): Long {
    val result = driver.execute(1_793_768_152, """DELETE FROM Skills""", 0).await()
    notifyQueries(1_793_768_152) { emit ->
      emit("Skills")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteSkillById(_id: String?): Long {
    val result = driver.execute(null,
        """DELETE FROM Skills WHERE _id ${ if (_id == null) "IS" else "=" } ?""", 1) {
          bindString(0, _id)
        }.await()
    notifyQueries(-70_493_352) { emit ->
      emit("Skills")
    }
    return result
  }

  private inner class GetWorkspaceByIdQuery<out T : Any>(
    public val _id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Workspace", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Workspace", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT Workspace.id, Workspace._id, Workspace.name, Workspace.type, Workspace.user_id, Workspace.plan, Workspace.workspaceType, Workspace.lastAccessed FROM Workspace WHERE _id ${ if (_id == null) "IS" else "=" } ?""",
        mapper, 1) {
      bindString(0, _id)
    }

    override fun toString(): String = "AppDatabase.sq:getWorkspaceById"
  }

  private inner class GetPlanByIdQuery<out T : Any>(
    public val _id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Plan", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Plan", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT Plan.id, Plan._id, Plan.name, Plan.price, Plan.perMonth, Plan.description, Plan.storage, Plan.planSupport, Plan.limitUsers, Plan.limitManagers, Plan.isPopular, Plan.currency, Plan.interval, Plan.stripeProductId, Plan.stripePriceId, Plan.type, Plan.descriptions, Plan.names, Plan.storages, Plan.planSupports FROM Plan WHERE _id ${ if (_id == null) "IS" else "=" } ?""",
        mapper, 1) {
      bindString(0, _id)
    }

    override fun toString(): String = "AppDatabase.sq:getPlanById"
  }

  private inner class GetJobsByWorkspaceIdQuery<out T : Any>(
    public val workspaceId: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Job", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Job", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT Job.id, Job._id, Job.jobTitle, Job.status, Job.assignees, Job.creatorId, Job.workspaceId, Job.start_at, Job.end_at, Job.repeat, Job.repeatInterval, Job.startDate, Job.dueDate, Job.jobDuration, Job.steps, Job.userId, Job.contactId, Job.contactSiteName, Job.contactParentId, Job.notes, Job.fileObjects, Job.completionReport FROM Job WHERE workspaceId ${ if (workspaceId == null) "IS" else "=" } ?""",
        mapper, 1) {
      bindString(0, workspaceId)
    }

    override fun toString(): String = "AppDatabase.sq:getJobsByWorkspaceId"
  }

  private inner class GetJobsByContactIdQuery<out T : Any>(
    public val contactParentId: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Job", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Job", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT Job.id, Job._id, Job.jobTitle, Job.status, Job.assignees, Job.creatorId, Job.workspaceId, Job.start_at, Job.end_at, Job.repeat, Job.repeatInterval, Job.startDate, Job.dueDate, Job.jobDuration, Job.steps, Job.userId, Job.contactId, Job.contactSiteName, Job.contactParentId, Job.notes, Job.fileObjects, Job.completionReport
    |FROM Job
    |WHERE contactParentId ${ if (contactParentId == null) "IS" else "=" } ?
    """.trimMargin(), mapper, 1) {
      bindString(0, contactParentId)
    }

    override fun toString(): String = "AppDatabase.sq:getJobsByContactId"
  }

  private inner class GetJobByIdQuery<out T : Any>(
    public val _id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Job", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Job", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT Job.id, Job._id, Job.jobTitle, Job.status, Job.assignees, Job.creatorId, Job.workspaceId, Job.start_at, Job.end_at, Job.repeat, Job.repeatInterval, Job.startDate, Job.dueDate, Job.jobDuration, Job.steps, Job.userId, Job.contactId, Job.contactSiteName, Job.contactParentId, Job.notes, Job.fileObjects, Job.completionReport
    |FROM Job
    |WHERE _id ${ if (_id == null) "IS" else "=" } ?
    """.trimMargin(), mapper, 1) {
      bindString(0, _id)
    }

    override fun toString(): String = "AppDatabase.sq:getJobById"
  }

  private inner class GetContactByIdQuery<out T : Any>(
    public val _id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Contact", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Contact", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT Contact.id, Contact._id, Contact.name, Contact.contactType, Contact.industry, Contact.address, Contact.email, Contact.phone, Contact.personName, Contact.personEmail, Contact.personAddress, Contact.personPhone, Contact.workspaceId
    |FROM Contact
    |WHERE _id ${ if (_id == null) "IS" else "=" } ?
    """.trimMargin(), mapper, 1) {
      bindString(0, _id)
    }

    override fun toString(): String = "AppDatabase.sq:getContactById"
  }

  private inner class GetSiteByIdQuery<out T : Any>(
    public val _id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Site", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Site", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT Site.id, Site._id, Site.personName, Site.personAddress, Site.personPhone, Site.siteName, Site.parentId, Site.parentName, Site.personEmail, Site.workspaceId
    |FROM Site
    |WHERE _id ${ if (_id == null) "IS" else "=" } ?
    """.trimMargin(), mapper, 1) {
      bindString(0, _id)
    }

    override fun toString(): String = "AppDatabase.sq:getSiteById"
  }

  private inner class GetSitesByContactIdQuery<out T : Any>(
    public val _id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Site", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Site", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT Site.id, Site._id, Site.personName, Site.personAddress, Site.personPhone, Site.siteName, Site.parentId, Site.parentName, Site.personEmail, Site.workspaceId
    |FROM Site
    |WHERE parentId ${ if (_id == null) "IS" else "=" } ?
    """.trimMargin(), mapper, 1) {
      bindString(0, _id)
    }

    override fun toString(): String = "AppDatabase.sq:getSitesByContactId"
  }

  private inner class GetSkillsByWorkspaceIdQuery<out T : Any>(
    public val workspaceId: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Skills", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Skills", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT Skills.id, Skills._id, Skills.name, Skills.workspaceId FROM Skills WHERE workspaceId ${ if (workspaceId == null) "IS" else "=" } ?""",
        mapper, 1) {
      bindString(0, workspaceId)
    }

    override fun toString(): String = "AppDatabase.sq:getSkillsByWorkspaceId"
  }
}
